/**
 * Get the short brand code from the full manufacturer string
 * @param {string} brand
 */
export default function(manufacturers = []) {
    let manufacturer;
    if (typeof manufacturers == 'object') {
        if (manufacturers.length == 1) {
            manufacturer = manufacturers[0];
        } else {
            return 'randd';
        }
    } else {
        manufacturer = manufacturers;
    }

    manufacturer = String(manufacturer).toLocaleLowerCase();

    if (manufacturer == 'peugeot') {
        return 'peugeot';
    }
    if (manufacturer == 'citroen') {
        return 'citroen';
    }
    if (manufacturer == 'citroën') {
        return 'citroen';
    }
    if (manufacturer == 'vauxhall') {
        return 'vauxhall';
    }
    if (manufacturer == 'ds automobiles') {
        return 'ds';
    }
    if (manufacturer == 'ds') {
        return 'ds';
    }
    if (manufacturer == 'fiat') {
        return 'fiat';
    }
    if (manufacturer == 'abarth') {
        return 'abarth';
    }
    if (manufacturer == 'jeep') {
        return 'jeep';
    }
    if (manufacturer == 'alfa') {
        return 'alfa-romeo';
    }
    if (manufacturer == 'alfa romeo') {
        return 'alfa-romeo';
    }
    if (manufacturer == 'leapmotor') {
        return 'leapmotor';
    }

    return 'randd';
}